module.exports = __webpack_public_path__ + "img/error-sign.a7082b8b.svg";